const tableOfContentsList = document.querySelector('.c-links-list.table-of-contents');
if(tableOfContentsList) {
  function headingToId(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '') // Remove special chars
      .replace(/\s+/g, '-') // Spaces to dashes
      .replace(/-+/g, '-');
  }

  // GET MAIN CONTENT
  const postContent = document.querySelector('.c-richtext.main-content');
  if (postContent) {
    const headings = Array.from(postContent.querySelectorAll('h2, h3'));
    const tocLinks = Array.from(tableOfContentsList.querySelectorAll('a[href^="#"]'));

    // Assign IDs to headings AND update matching ToC hrefs using the same algorithm,
    // so they always match regardless of what WeGlot does to either.
    function syncAnchors() {
      const counts = {};
      headings.forEach(function(heading, i) {
        const text = heading.textContent || heading.innerText || '';
        const baseId = headingToId(text);

        let id = baseId;
        if (counts[baseId] !== undefined) {
          counts[baseId] += 1;
          id = baseId + '-' + counts[baseId];
        } else {
          counts[baseId] = 1;
        }

        heading.setAttribute('id', id);

        // Update the corresponding ToC link href to match
        if (tocLinks[i]) {
          tocLinks[i].setAttribute('href', '#' + id);
        }
      });
    }

    syncAnchors();

    // Re-sync when WeGlot translates heading text. Observing text changes (not
    // attribute changes) avoids infinite loops from our own setAttribute calls.
    let debounceTimer;
    const observer = new MutationObserver(function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncAnchors, 50);
    });
    headings.forEach(function(heading) {
      observer.observe(heading, { childList: true, subtree: true, characterData: true });
    });
  }
}